import { Cartao } from '../componentes/ui';

export function NaoEncontrada() {
  return (
    <main className="mx-auto max-w-xl p-4 sm:p-8">
      <Cartao>
        <h1 className="text-xl font-semibold">Página não encontrada</h1>
        <p className="mt-2 text-slate-600">Confira o link que você recebeu no WhatsApp.</p>
      </Cartao>
    </main>
  );
}
